import { Locale } from 'modules/i18n';

export const copyButtonTranslation = {
  [Locale.en]: {
    copied: 'Copied!',
  },
};
